import React, { useState } from 'react';
import { Outlet, useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import logo from '../../image/logo.png';

const AdminLayout = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobOpen, setMobOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  const titles = {
    '/': 'Dashboard', '/users': 'Users', '/orders': 'Orders',
    '/offer': 'Offer Banners', '/registerlist': 'Vendors',
    '/coupon': 'Coupons', '/category': 'Categories', '/create': 'Create Admin',
    '/delivery-boys': 'Delivery Partners', '/products': 'Products & Inventory',
  };
  const pageTitle = titles[location.pathname] || 'Dashboard';

  const NavItem = ({ to, icon, label }) => {
    const active = location.pathname === to;
    return (
      <li className={`sb-item${active ? ' active' : ''}`}>
        <Link to={to} data-tip={label} onClick={() => setMobOpen(false)}>
          <span className="sb-icon"><i className={icon} /></span>
          <span className="sb-label">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <div className="admin-layout">
      <div className={`sb-backdrop${mobOpen ? ' on' : ''}`} onClick={() => setMobOpen(false)} />

      <aside className={`sidebar${collapsed ? ' collapsed' : ''}${mobOpen ? ' mob-open' : ''}`}>
        <div className="sb-head">
          <span className="sb-logo">Quick<span>.</span></span>
          <button className="sb-toggle" onClick={() => setCollapsed(c => !c)}>
            <i className={`fas fa-chevron-${collapsed ? 'right' : 'left'}`} />
          </button>
        </div>

        <div className="sb-user">
          <div className="sb-avatar"><img src={logo} alt="" /></div>
          <div className="sb-uinfo">
            <div className="sb-uname">{currentUser?.name || 'Admin'}</div>
            <div className="sb-urole">{currentUser?.isSuperAdmin ? 'Super Admin' : 'Admin'}</div>
          </div>
        </div>

        <nav className="sb-nav">
          <div className="sb-section">
            <div className="sb-section-title">Main</div>
            <ul>
              <NavItem to="/" icon="fas fa-th-large" label="Dashboard" />
            </ul>
          </div>
          <div className="sb-section">
            <div className="sb-section-title">Management</div>
            <ul>
              <NavItem to="/registerlist" icon="fas fa-store" label="Vendors" />
              <NavItem to="/users" icon="fas fa-users" label="Users" />
              <NavItem to="/orders" icon="fas fa-receipt" label="Orders" />
              <NavItem to="/delivery-boys" icon="fas fa-truck" label="Delivery Partners" />
            </ul>
          </div>
          <div className="sb-section">
            <div className="sb-section-title">Catalogue</div>
            <ul>
              <NavItem to="/products" icon="fas fa-boxes" label="Products" />
              <NavItem to="/category" icon="fas fa-layer-group" label="Categories" />
              <NavItem to="/coupon" icon="fas fa-tag" label="Coupons" />
              <NavItem to="/offer" icon="fas fa-image" label="Offer Banners" />
            </ul>
          </div>
          {currentUser?.isSuperAdmin && (
            <div className="sb-section">
              <div className="sb-section-title">Admin</div>
              <ul>
                <NavItem to="/create" icon="fas fa-user-shield" label="Create Admin" />
              </ul>
            </div>
          )}
        </nav>

        <div className="sb-foot">
          <button className="sb-logout" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt" />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="main-content">
        <header className="top-bar">
          <div className="top-bar-left">
            <button className="hamburger" onClick={() => setMobOpen(o => !o)}>
              <i className="fas fa-bars" />
            </button>
            <div>
              <h1>{pageTitle}</h1>
              <div className="bc">Home / <span className="bc-active">{pageTitle}</span></div>
            </div>
          </div>
          <div className="top-bar-right">
            <span className="top-bar-user">{currentUser?.name}</span>
            <button className="btn btn-outline btn-sm" onClick={handleLogout}>
              <i className="fas fa-power-off" />
            </button>
          </div>
        </header>

        <div className="content-area"><Outlet /></div>

        <footer className="main-footer">© 2025 AP IT Services</footer>
      </main>
    </div>
  );
};

export default AdminLayout;
